export default "__VITE_ASSET__26fe6369__"